import type { NextPage } from 'next';
import { useState } from 'react';

import type { Winner } from '@src/@types/ozonPrizeWinners';
import { PageHead } from '@src/components/PageHead';
import { Layout } from 'app/Layout';
import {
  OctoberPrizeDrawBanner,
  OctoberPrizeDrawHistories,
  OctoberPrizeDrawPrizeWinners,
} from 'entities/Banner/ui/OctoberPrizeDraw';
import { OctoberPrizeResult } from 'entities/Banner/ui/OctoberPrizeDraw/OctoberPrizeResult';

const PAGE_TITLE = 'Розыгрыш Ozon';

export const OctoberPrizeDrawPage: NextPage = () => {
  const [currentWinner, setCurrentWinner] = useState<Winner | null>(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Layout seoJsonSchemaConfig={false}>
      <PageHead title={PAGE_TITLE} />
      <OctoberPrizeDrawBanner setCurrentWinner={setCurrentWinner} setIsSubmitted={setIsSubmitted} />
      {isSubmitted ? (
        <OctoberPrizeResult currentWinner={currentWinner} />
      ) : (
        <>
          <OctoberPrizeDrawPrizeWinners />
          <OctoberPrizeDrawHistories />
        </>
      )}
    </Layout>
  );
};
